module.exports = __webpack_public_path__ + "static/img/wifi_pro.879d086c.png";